import React, { FC, useEffect } from 'react';

import { Navigate } from 'react-router-dom';

import * as analytics from '@adsk/acs-web-analytics';
import { report, REPORT_TYPES } from '@adsk/exo-skeleton-api';
import {
  safeStringify,
  wrapWithEventPropertiesPrefix,
} from '@adsk/exo-skeleton-api/internal';

import { ANALYTICS_TYPES } from '../../analytics';
import { EXO_SKELETON_SCOPE_NAME } from '../../consts';
import { REPORT_EVENT_TYPES } from '../../utils/monitoring';

export const PageNotFoundRedirect: FC = () => {
  useEffect(() => {
    analytics.track(ANALYTICS_TYPES.EXO_NAVIGATE_RESULT_404, {
      requested_url: window.location.href,
    });

    const unsafeGlobalContext = {
      type: REPORT_EVENT_TYPES.PAGE_NOT_FOUND,
      requested_url: window.location.href,
    };

    const error = new Error('Page not found');
    void report({
      scope: EXO_SKELETON_SCOPE_NAME,
      type: REPORT_TYPES.warning,
      value: error,
      context: {
        ...wrapWithEventPropertiesPrefix({
          data: safeStringify(unsafeGlobalContext),
          stack: error.stack,
          message: error.message,
          type: REPORT_TYPES.warning,
        }),
      },
      UNSAFE__globalContext: unsafeGlobalContext,
    });
  }, []);

  return <Navigate to="/page-not-found" replace />;
};
